import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import ServerStats from '../ServerStats/ServerStats';
import PlayersPanel from '../PlayersPanel/PlayersPanel';
import CommandPanel from '../CommandPanel/CommandPanel';
import './HomePage.scss';

const HomePage = () => {
    const [searchParams] = useSearchParams();
    const showRcon = searchParams.get('rcon') === 'true';

    return (
        <div className="home-page">

            <ServerStats />
            <PlayersPanel />
            {showRcon && <CommandPanel />}
            <div className="navigation-bar">
                <Link to="/map" className="nav-link map-link">
                    <img
                        src={'/items/filled_map.png'}
                        alt="Map"
                        className="item-image"
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                        }}
                    />View Interactive Map
                </Link>
            </div>
        </div>
    );
};

export default HomePage;